// External Imports
import { Link } from "react-router-dom"

// Internal Imports
import routes from "../../../utils/routes"
import {Typography} from "antd";

// Assets Imports
import TecmeLogoWhite from './assets/images/logo-white.svg'
import FacebookIcon from './assets/icons/facebook.svg'
import InstagramIcon from './assets/icons/instagram.svg'
import FooterPhoneIcon from './assets/icons/footer-phone.svg'
import FooterMailIcon from './assets/icons/footer-mail.svg'
import FooterHelpIcon from './assets/icons/footer-help.svg'

import './assets/css/footer.scss'
import {getMarketingWebsiteURL} from "../../../utils/helper";
const marketingWebsiteURL = getMarketingWebsiteURL()
const { Paragraph, Text, Title } = Typography

const Footer = () => {
    return (
        <div className='footer-container'>
            <div className='footer'>
                <div className="logo-container">
                    <img src={TecmeLogoWhite} alt="TecMe" className='logo' />
                </div>
                <div className='links-container'>
                    <div className='link-and-heading'>
                        <Text strong={true} style={{fontSize:16, color: 'white'}}>For businesses</Text>
                        <a href={`${marketingWebsiteURL}/contact-us`} target={"_blank"}>Contact us</a>

                        {/* <Link to={routes.ABOUT}>Referral program</Link> */}
                        <Link to={routes.DISCOVERY_EXPERIENCE}>Find local specialists</Link>
                    </div>
                    <div className='link-and-heading'>
                        <Text strong={true} style={{fontSize:16, color: 'white'}}>For IT specialists</Text>
                        <a href={`https://tecme.recruitee.com/`} target={"_blank"}>Join the TecMe network</a>
                        <a href={`https://hub.tecme.io/`} target={"_blank"}>Community</a>
                    </div>
                    <div className='link-and-heading'>
                        <Text strong={true} style={{fontSize:16, color: 'white'}}>Company</Text>
                        <a href={`${marketingWebsiteURL}/about`} target={"_blank"}>About us</a>
                        <a href={`${marketingWebsiteURL}/press-room`} target={"_blank"}>Press</a>
                    </div>
                    <div className='link-and-heading'>
                        <Text strong={true} style={{fontSize:16, color: 'white'}}>Support</Text>
                        <a href="tel:+1 (888) 678-3263">
                           <div><img src={FooterPhoneIcon} alt="" className="support-icon" /></div>
                           <p>(888) 678-3263</p>
                        </a>
                        <a href="mailto:support@tecme.io">
                            <div><img className="support-icon" src={FooterMailIcon} alt="" /></div>
                            <p>support@tecme.io</p> 
                        </a>
                        <a href="https://help.tecme.io/" target="_blank">
                            <div><img className="support-icon" src={FooterHelpIcon} alt="" /></div>
                            <p>Help center</p> 
                        </a>
                    </div>
                    <div className='link-and-heading'>
                        <Text strong={true} style={{fontSize:16, color: 'white'}}>Why TecMe</Text>
                        <p>
                            TecMe empowers SMBs with high quality IT solutions &
                            expertise that can be tailored to any budget. We make
                            it easy to find & engage with specialists in all areas of IT.
                            From end-user support to cybersecurity strategy, our
                            combination of solutions & talent has you covered.
                        </p>
                    </div>
                    
                </div>
                <div className='bottom-section'>
                    <p>Copyright © {new Date().getFullYear()} TecMe. All Rights Reserved</p>
                    <div className='right-side'>
                        <div className='social-links'>
                            <img src={FacebookIcon} onClick={() => window.open("https://www.facebook.com/tecme.io")}/>
                            <img src={InstagramIcon} onClick={() => window.open("https://www.instagram.com/tecme.io")}/>
                        </div>
                        <a href={`${marketingWebsiteURL}/terms-of-service/`} target={"_blank"}>Terms of Service</a>
                        <a href={`${marketingWebsiteURL}/privacy-policy/`} target={"_blank"}>Privacy Policy</a>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Footer